import { useEffect } from 'react';
import {
  createTechDocsAddonExtension,
  TechDocsAddonLocations,
  useShadowRootElements,
} from '@backstage/plugin-techdocs-react';
import { useIsGuest } from '../guest';
import { guestTechDocsAddonsPlugin } from './guestTechDocsAddonsPlugin';

const repositoryLinkSelectors = [
  'a.md-content__button[title="Edit this page"]',
  'a.md-content__button[href*="/edit/"]',
  'a#git-feedback-link',
];

const GuestHideRepositoryLinksAddon = () => {
  const isGuest = useIsGuest();
  const repositoryLinks = useShadowRootElements<HTMLAnchorElement>(
    repositoryLinkSelectors,
  );

  useEffect(() => {
    if (isGuest) {
      repositoryLinks.forEach(link => {
        link.style.display = 'none';
      });
    }
  });

  return null;
};

export const GuestHideRepositoryLinks = guestTechDocsAddonsPlugin.provide(
  createTechDocsAddonExtension({
    name: 'GuestHideRepositoryLinks',
    location: TechDocsAddonLocations.Content,
    component: GuestHideRepositoryLinksAddon,
  }),
);
